import { searchString } from '@/services/router/search-scalars';

/**
 * The People list page's search params. All of them are written and read by
 * `usePeopleListPage` (nuqs); declared here so typed `Link`s can build
 * filtered views and deep links survive validation.
 */
export type PeopleListSearch = {
  /** Email search term (mutually exclusive with `filters` server-side). */
  email?: string;
  /** Base64-encoded condition filters. */
  filters?: string;
  /** 1-based page number. */
  page?: number;
  /** Analytics attribution for inbound links (e.g. `segment_people`); consumed after one load. */
  source?: string;
};

/**
 * `validateSearch` replaces this route's search, so the incoming params are
 * spread to preserve global ones the page doesn't own (masq_account_id, …) and
 * only the ones it does are narrowed.
 */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
export function validatePeopleListSearch(search: Record<string, unknown>): Record<string, unknown> & PeopleListSearch {
  return {
    ...search,
    email: searchString(search.email),
    filters: typeof search.filters === 'string' ? search.filters : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    source: typeof search.source === 'string' ? search.source : undefined,
  };
}
